import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import React from "react";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const EmptyTrashBinButton = (props: IAppButtonProps) => (
    <AppButton
        variant="text"
        color="error"
        startIcon={<DeleteForeverIcon />}
        {...props}>
        {props.children}
    </AppButton>
);
